import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "react-bootstrap";
import TopHeader from "../Component/TopHeader";
import VehiclesFilters from "../Component/Filters/VehiclesFilters";
import { vehiclesList } from "../../Constants";
import UserSideBarMenu from "../Component/UserSidebarMenu";
import {
  deleteAdminVehicleAction,
  getAdminVehiclesListAction,
} from "../../Store/Actions/VehicleActions";
import { display, showToast } from "../../utils/helper";
import { trackEvent } from "../../utils/analytics";
import SideBarMenu from "../Component/SideBarMenu";
import AddVehicleModal from "../Component/Models/AddVehicleModal";
import KebabMenu from "../Component/KebabMenu";
import FilterPopover from "../Component/FilterPopover";
import Pagination from "../Component/Pagination";
import ConfirmModal from "../Component/Models/ConfirmModal";

const VehiclesList = () => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  const rightSidebar = useSelector((state) => state.auth.isRightSidebarOpen);
  const { adminVehicles } = useSelector((state) => state.vehicles);

  const [loading, setLoading] = useState(false);
  const [delLoading, setDelLoading] = useState({});
  const [filters, setFilters] = useState({});
  const [addVehicleModal, setAddVehicleModal] = useState({
    show: false,
    vehicle: null,
  });
  const [confirmDel, setConfirmDel] = useState({ show: false, item: null });
  const [showSidebar, toggleShowRightSidebar] = useState({
    show: false,
    item: {},
  });

  const stripEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
    );

  const [pagging, setPagging] = useState({
    totalItems: "",
    itemsPerPage: "",
    currentPage: "",
    totalPages: "",
    nextPage: 1,
    limit: 15,
  });

  const askDeleteVehicle = (item) => {
    if (delLoading[item.id]) return;
    setConfirmDel({ show: true, item });
  };

  const performDeleteVehicle = () => {
    const item = confirmDel.item;
    if (!item || delLoading[item.id]) return;

    setDelLoading({ ...delLoading, [item.id]: true });

    deleteAdminVehicleAction({ id: item.id }, dispatch)
      .then((res) => {
        setDelLoading({ ...delLoading, [item.id]: false });
        setConfirmDel({ show: false, item: null });
        if (res && res.type === "success") {
          trackEvent("web_vehicle_deleted", {
            vehicle_id: item.id,
            role: "admin",
          });
        }
        showToast(res.message);
      })
      .catch((err) => {
        setDelLoading({ ...delLoading, [item.id]: false });
        setConfirmDel({ show: false, item: null });
        showToast(err.message);
      });
  };

  const getVehicleList = (page = 1, overrideFilters) => {
    if (!loading) {
      setLoading(true);

      const listParams = {
        page,
        limit: pagging.limit,
        ...stripEmpty(overrideFilters || filters),
      };

      getAdminVehiclesListAction(listParams, dispatch)
        .then((res) => {
          setLoading(false);
          if (res.type === "success") {
            setPagging({
              ...pagging,
              ...res.pagination,
            });
          }
        })
        .catch((err) => {
          setLoading(false);

          showToast("error", err.message);
        });
    }
  };

  const renderPagging = () => (
    <Pagination
      currentPage={pagging.currentPage || 1}
      totalPages={pagging.totalPages || 1}
      totalItems={pagging.totalItems}
      onPageChange={(p) => getVehicleList(p)}
    />
  );

  useEffect(() => {
    if (adminVehicles.length === 0) {
      getVehicleList();
    }
  }, []);

  return (
    <div className={`app-wrapper ${menuState ? "open" : ""} `}>
      <SideBarMenu />

      <div className="content-wrapper">
        <TopHeader title={"Vehicles"} />

        <div className="content">
          <div className="list-toolbar">
            <div className="list-toolbar-spacer" />

            <FilterPopover
              count={
                Object.values(filters).filter(
                  (v) => v !== "" && v !== null && v !== undefined,
                ).length
              }
            >
              {(close) => (
                <VehiclesFilters
                  initial={filters}
                  onApply={(values) => {
                    setFilters(values);
                    getVehicleList(1, values);
                    close();
                  }}
                />
              )}
            </FilterPopover>

            <Button
              variant=""
              className="list-add-btn"
              onClick={() => setAddVehicleModal({ show: true, vehicle: null })}
            >
              <span>
                <i className="fas fa-plus me-1" />
                Add Vehicle
              </span>
            </Button>
          </div>

              <div className="data-listing">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th width="13%">Vehicle Name</th>
                      <th width="18%">License Plate</th>
                      <th width="4%" className="text-center">
                        Color
                      </th>
                      <th width="6%" className="text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminVehicles.length > 0 &&
                      adminVehicles.map((item) => (
                        <tr key={`veh-${item.id}`}>
                          <td>{display(item.name)}</td>
                          <td>{display(item.licensePlate)}</td>

                          <td className="text-center">
                            <span
                              style={{
                                width: 25,
                                height: 25,
                                borderRadius: "50%",
                                backgroundColor: item.color,
                                display: "inline-block",
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <KebabMenu
                              items={[
                                {
                                  label: "Edit",
                                  icon: "fas fa-pen",
                                  onClick: () =>
                                    setAddVehicleModal({
                                      show: true,
                                      vehicle: item,
                                    }),
                                },
                                {
                                  label: delLoading[item.id]
                                    ? "Deleting…"
                                    : "Delete",
                                  icon: "fas fa-trash",
                                  danger: true,
                                  disabled: !!delLoading[item.id],
                                  onClick: () => askDeleteVehicle(item),
                                },
                              ]}
                            />
                          </td>
                        </tr>
                      ))}
                    {adminVehicles.length === 0 && (
                      <tr>
                        <td colSpan="6">
                          <p className="text-center">No Vehicles Available.</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {renderPagging()}
        </div>
      </div>

      {addVehicleModal.show && (
        <AddVehicleModal
          show={addVehicleModal.show}
          vehicle={addVehicleModal.vehicle}
          onClose={() => setAddVehicleModal({ show: false, vehicle: null })}
          onSuccess={() => {
            setAddVehicleModal({ show: false, vehicle: null });
            getVehicleList(pagging.currentPage || 1);
          }}
        />
      )}

      <ConfirmModal
        show={confirmDel.show}
        title="Delete Vehicle"
        message={
          confirmDel.item
            ? `Are you sure want to delete "${confirmDel.item.name}"?`
            : "Are you sure want to delete it?"
        }
        busy={confirmDel.item ? !!delLoading[confirmDel.item.id] : false}
        onClose={() => setConfirmDel({ show: false, item: null })}
        onConfirm={performDeleteVehicle}
      />
    </div>
  );
};

export default VehiclesList;
